module.exports = __webpack_public_path__ + "static/media/tgle-rewards.5c8256b7.png";